// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2zFX6","title":"AfterBackImages_title__1sO4p","images":"AfterBackImages_images__31-yh"};